/**
 * The app's single React Query client.
 *
 * Extracted from `main.tsx` 2026-08-11 so that non-React code can seed the cache — specifically
 * `api/useEnquiryMutations.ts`'s write primitives, which hold the authoritative post-write
 * enquiry document and previously threw it away, leaving React Query to fetch the same document
 * again. On this bench that redundant fetch costs ~0.85s on every line edit (see
 * `updateEnquiryItems`).
 *
 * `main.tsx` still owns the provider; this module owns only the instance, so there is exactly one
 * client and no chance of a second one silently serving a different cache.
 */

import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Enquiry state is derived server-side and moves without this tab asking (see
      // `lib/api/polling.ts`), so a backgrounded tab is stale by the time you return to it.
      // Cheap, because focus-refetch RESPECTS `staleTime` — unlike `refetchInterval`, which
      // ignores it. The static masters keep their long `staleTime` and so stay quiet here until
      // it elapses; only genuinely-stale mounted queries cost a request.
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      retry: 1,
    },
  },
})
